'use client';

import { GlobalInternalErrorBoundary } from '@/shared/components/GlobalErrorBoundary.client';

export default GlobalInternalErrorBoundary;
